import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  flex-direction: column;
  max-width: 300px;
`;

export default Container;
